import React from 'react';
import NavigationBar from './NavigationBar';

function Layout({ children, user, cartCount, onCartClick, isAdmin = false }) {
  return (
    <div className="app-layout">
      <NavigationBar
        user={user}
        cartCount={cartCount}
        onCartClick={onCartClick}
        isAdmin={isAdmin}
      />
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
}

export default Layout;
